import { APIGetRequest } from '@ancon/wildcat-types'

import Request from '../../client/Request'
import { APIType } from '../../types'
import endpoints from '../endpoints'
import { GuestRestaurant } from '../../../features/booking/types'

type RestaurantsAPI = {
  get: {
    list: APIGetRequest<
      GuestRestaurant[],
      {
        city?: string
        businessDate: string
        from: string
        until: string
        partySize: number
        limit?: number
      }
    >
  }
}

const restaurants: RestaurantsAPI = {
  get: {
    list: new Request(endpoints.reservation.restaurants.list, {
      apiType: APIType.Reservation,
    }).get,
  },
}

export default restaurants
